import produce from "immer";
import { LoadState } from "../../constants/enums";
import { IStoreState } from "../initialStoreState";
import {
  initialSubscriptionPlanState,
  initialUserSubscription,
  initialRestrictedModule,
  defaultSubscriptionPlan,
} from "./subscription.state";
import {
  FETCH_SUBSCRIPTION_PLAN_LIST_PROGRESS,
  FETCH_SUBSCRIPTION_PLAN_LIST_SUCCESS,
  FETCH_SUBSCRIPTION_PLAN_LIST_FAILED,
  FETCH_SUBSCRIPTION_PLAN_PROGRESS,
  FETCH_SUBSCRIPTION_PLAN_SUCCESS,
  FETCH_SUBSCRIPTION_PLAN_FAILED,
  CLEAR_SUBSCRIPTION_PLAN_STATE,
  FETCH_USER_SUBSCRIPTION_LIST_PROGRESS,
  FETCH_USER_SUBSCRIPTION_LIST_SUCCESS,
  FETCH_USER_SUBSCRIPTION_LIST_FAILED,
  FETCH_USER_SUBSCRIPTION_PROGRESS,
  FETCH_USER_SUBSCRIPTION_SUCCESS,
  FETCH_USER_SUBSCRIPTION_FAILED,
  CLEAR_USER_SUBSCRIPTION_STATE,
  FETCH_RESTRICTED_MODULE_PROGRESS,
  FETCH_RESTRICTED_MODULE_SUCCESS,
  FETCH_RESTRICTED_MODULE_FAILED,
  CLEAR_RESTRICTED_MODULE_STATE,
  UPDATE_SUBSCRIPTION_PLAN_SUCCESS,
} from "./subscriptionAction";
import { error_message } from "../../constants/constants";
import { ISubscriptionActions } from ".";

export const subscriptionPlanReducer = (
  state: IStoreState["subscriptionPlan"] = initialSubscriptionPlanState,
  action: ISubscriptionActions
) => {
  switch (action.type) {
    // List Actions
    case FETCH_SUBSCRIPTION_PLAN_LIST_PROGRESS: {
      return produce(state, (draftState) => {
        draftState.list.loading = LoadState.InProgress;
        draftState.list.list = [];
        draftState.list.totalRecords = 0;
      });
    }

    case FETCH_SUBSCRIPTION_PLAN_LIST_SUCCESS: {
      const { data } = action.payload;
      return produce(state, (draftState) => {
        draftState.list.loading = LoadState.Loaded;
        draftState.list.list = data;
        draftState.list.error = null;
      });
    }



    case FETCH_SUBSCRIPTION_PLAN_LIST_FAILED: {
      const { error } = action.payload;
      return produce(state, (draftState) => {
        draftState.list.loading = LoadState.Failed;
        draftState.list.list = [];
        draftState.list.error = error;
      });
    }

    // Upsert Single Subscription Plan Actions
    case UPDATE_SUBSCRIPTION_PLAN_SUCCESS: {
      return produce(state, (draftState) => {
         console.log("subscription recer called", action.payload)
        const isExisting = draftState.list.list.findIndex(plan => plan.subscription_plan_uuid ===  action.payload.subscription_plan_uuid)
        if(isExisting > -1) {
          console.log("subscription isExisting", isExisting)
          draftState.list.list[isExisting] = action.payload
        } else {
          console.log("subscription new", action.payload)
           draftState.list.list.push(action.payload)
        }
      });
    }

    // Single Subscription Plan Actions
    case FETCH_SUBSCRIPTION_PLAN_PROGRESS: {
      return produce(state, (draftState) => {
        draftState.subscriptionPlan.loading = LoadState.InProgress;
        draftState.subscriptionPlan.data = defaultSubscriptionPlan;
      });
    }

    case FETCH_SUBSCRIPTION_PLAN_SUCCESS: {
      const { data } = action.payload;
      return produce(state, (draftState) => {
        draftState.subscriptionPlan.loading = LoadState.Loaded;
        draftState.subscriptionPlan.data = data;
        draftState.subscriptionPlan.error = null;
      });
    }

    case FETCH_SUBSCRIPTION_PLAN_FAILED: {
      return produce(state, (draftState) => {
        draftState.subscriptionPlan.loading = LoadState.Failed;
      });
    }

    // User Subscription List Actions
    case FETCH_USER_SUBSCRIPTION_LIST_PROGRESS: {
      return produce(state, (draftState) => {
        draftState.userSubscriptionList.loading = LoadState.NotLoaded;
        draftState.userSubscriptionList.list = [];
        draftState.userSubscriptionList.totalRecords = 0;
      });
    }

    case FETCH_USER_SUBSCRIPTION_LIST_SUCCESS: {
      const { data } = action.payload;
      return produce(state, (draftState) => {
        draftState.userSubscriptionList.loading = LoadState.Loaded;
        draftState.userSubscriptionList.list = data;
      });
    }

    case FETCH_USER_SUBSCRIPTION_LIST_FAILED: {
      return produce(state, (draftState) => {
        draftState.userSubscriptionList.loading = LoadState.Failed;
        draftState.userSubscriptionList.error = action.payload;
      });
    }

    // User Subscription Actions
    case FETCH_USER_SUBSCRIPTION_PROGRESS: {
      return produce(state, (draftState) => {
        draftState.userSubscription.loading = LoadState.InProgress;
        draftState.userSubscription.data = initialUserSubscription;
      });
    }

    case FETCH_USER_SUBSCRIPTION_SUCCESS: {
      const { data } = action.payload;
      return produce(state, (draftState) => {
        draftState.userSubscription.loading = LoadState.Loaded;
        draftState.userSubscription.data = data;
      });
    }

    case FETCH_USER_SUBSCRIPTION_FAILED: {
      return produce(state, (draftState) => {
        draftState.userSubscription.loading = LoadState.Failed;
      });
    }

    // Restricted Module Actions
    case FETCH_RESTRICTED_MODULE_PROGRESS: {
      return produce(state, (draftState) => {
        draftState.restrictedModule.loading = LoadState.InProgress;
        draftState.restrictedModule.data = initialRestrictedModule;
      });
    }

    case FETCH_RESTRICTED_MODULE_SUCCESS: {
      const { data } = action.payload;
      return produce(state, (draftState) => {
        draftState.restrictedModule.loading = LoadState.Loaded;
        draftState.restrictedModule.data = data;
      });
    }

    case FETCH_RESTRICTED_MODULE_FAILED: {
      return produce(state, (draftState) => {
        draftState.restrictedModule.loading = LoadState.Failed;
      });
    }

    case CLEAR_RESTRICTED_MODULE_STATE: {
      return produce(state, (draftState) => {
        draftState.restrictedModule.data = initialRestrictedModule;
      });
    }

    case CLEAR_USER_SUBSCRIPTION_STATE: {
      return produce(state, (draftState) => {
        draftState.userSubscription.data = initialUserSubscription;
      });
    }

    case CLEAR_SUBSCRIPTION_PLAN_STATE: {
      return produce(state, (draftState) => {
        draftState.subscriptionPlan.data = defaultSubscriptionPlan;
      });
    }

    default: {
      return state;
    }
  }
};
